import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Empresa } from '../models/empresa';

export function getHeaders() {
  let headers = new HttpHeaders().append(
    'Content-Type',
    'application/json; charset=utf-8'
  );
  return headers;
}

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {
  uri = environment.urlApi.concat('/v1/empresa');

  constructor(private http: HttpClient) {}

  listById(ids: string[]) {
    return this.http.post<Empresa[]>(this.uri.concat('/listById'), ids, {
      headers: getHeaders(),
    });
  }
}